import { useState, useEffect, useRef } from "react";

export const useDataFetch = (asyncCallback, deps) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const initialLoading = useRef(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const result = await asyncCallback();

            setData(result);
            initialLoading.current = false;
            setLoading(false);
        })();
    }, deps || [asyncCallback]);

    return [data, loading, initialLoading.current];
};